import { CharacterMessage, type CharacterMessageProps } from "@hamlak/ui";

type Props = Omit<CharacterMessageProps, "narration" | "dialogue" | "markdown"> & { text?: string };

/** 캐릭터 본문(표준 마크다운: `*지문*`·기호 없는 대사·강조·인용 등)을 CharacterMessage로. 파싱 규칙은 shared parseNarrative. */
export function NarrativeText({ text = "", ...rest }: Props) {
  return <CharacterMessage markdown={text} {...rest} />;
}
